import React from 'react';
import PropTypes from 'prop-types';
import { FormControl } from 'react-bootstrap';
import map from 'lodash/map';
import humanizeString from 'humanize-string';

import SelectableRecordsTable from 'components/selectable_record_table/selectable_record_table';
import SelectableRow from 'components/selectable_record_table/selectable_row';

export default class FieldOverrideMapper extends React.Component {
  static propTypes = {
    fieldOverrideMapping: PropTypes.object.isRequired,
    overrideFields: PropTypes.object.isRequired,
    pluralizedObjectName: PropTypes.string.isRequired,
    onUpdateOverrideMapping: PropTypes.func
  }

  handleUpdateOverrideMapping = (e, buildoutField) => {
    const { value } = e.target;

    this.props.onUpdateOverrideMapping(buildoutField, value.length > 0 ? value : null);
  }

  columnHeaders = (
    <React.Fragment>
      <th>Buildout Field</th>
      <th>Value</th>
    </React.Fragment>
  )

  render() {
    const { fieldOverrideMapping, pluralizedObjectName } = this.props;

    return (
      <div className="py-5">
        <p>Bulk add values for all {pluralizedObjectName} in import</p>
        <SelectableRecordsTable
          className="field-mapping-table mb-5"
          columnHeaders={this.columnHeaders}
          hasSelectAll={false}
          hasSelectColumn={false}
          name="overrideMappingTable"
        >
          {map(fieldOverrideMapping, (value, buildoutField) => this.renderOverrideRow(buildoutField, value))}
        </SelectableRecordsTable>
      </div>
    );
  }

  renderOverrideRow(buildoutField, value) {
    const { overrideFields } = this.props;
    const { values } = overrideFields[buildoutField];

    return (
      <SelectableRow hideCheckbox key={buildoutField}>
        <td name="buildoutField">{humanizeString(buildoutField)}</td>
        <td>
          <FormControl
            className={value == null ? 'bg-warning' : ''}
            componentClass="select"
            name="valueSelect"
            value={value || ''}
            onChange={e => this.handleUpdateOverrideMapping(e, buildoutField)}
          >
            <option key="blank" value="">Select a field</option>
            {map(values, (id, label) => <option key={id} value={id}>{label}</option>)}
          </FormControl>
        </td>
      </SelectableRow>
    );
  }
}
